const dateFormat = {
  timeObjects: {
    year: "año",
    month: "mes",
    week: "semana",
    day: "día",
    hour: "hora",
    minute: "minuto",
    second: "segundo"
  },
  months: {
    jan: {
      short: "Ene",
      long: "Enero"
    },
    feb: {
      short: "Feb",
      long: "Febrero"
    },
    mar: {
      short: "Mar",
      long: "Marzo"
    },
    apr: {
      short: "Abr",
      long: "Abril"
    },
    may: {
      short: "May",
      long: "Mayo"
    },
    jun: {
      short: "Jun",
      long: "Junio"
    },
    jul: {
      short: "Jul",
      long: "Julio"
    },
    aug: {
      short: "Ago",
      long: "Agosto"
    },
    sep: {
      short: "Sep",
      long: "Septiembre"
    },
    oct: {
      short: "Oct",
      long: "Octubre"
    },
    nov: {
      short: "Nov",
      long: "Noviembre"
    },
    dec: {
      short: "Dic",
      long: "Deciembre"
    }
  },
  weekdays: {
    mon: {
      short: "Lun",
      long: "Lunes"
    },
    tue: {
      short: "Mar",
      long: "Martes"
    },
    wed: {
      short: "Mie",
      long: "Miércoles"
    },
    thr: {
      short: "Jue",
      long: "Jueves"
    },
    fri: {
      short: "Vie",
      long: "Viernes"
    },
    sat: {
      short: "Sab",
      long: "Sábado"
    },
    sun: {
      short: "Dom",
      long: "Domingo"
    }
  }
};
export default dateFormat;
